import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Scadenza } from 'src/app/common/models/scadenza';
import { Motivo } from 'src/app/common/models/tipologiche/motivo';
import { DialogRef } from 'src/app/core/components/dialog/dialog-ref';
import { HelpersService } from 'src/app/core/services/helpers.service';
import { OperationsService } from 'src/app/core/services/operations.service';

@Component({
  selector: 'app-scadenza-evadi',
  templateUrl: './scadenza-evadi.component.html',
  styleUrls: ['./scadenza-evadi.component.css']
})
export class ScadenzaEvadiComponent implements OnInit {
  scadenza: Scadenza;
  request: {
    dataEvasione: number;
    motivoEvasione: Motivo;
  } = { dataEvasione: null, motivoEvasione: null };
  evadiForm: FormGroup;
  motiviOptions: Motivo[] = [];
  oraSet: string;
  minutiSet: string;
  minSet;
  constructor(
    private dialogRef: DialogRef,
    private campiForm: FormBuilder, 
    private helpers: HelpersService
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    // this.initRequest();
    this.evadiForm = this.campiForm.group({
      dataEvasione: [this.request.dataEvasione, Validators.required],
      motivoEvasione: [this.request.motivoEvasione],
    });
    this.populateSelect();
  }

  populateSelect() {
    if (this.motiviOptions.length === 0) {
      this.helpers.getMotiviEvadiScadenza().subscribe(response => this.motiviOptions = response);
    }
  }

  save() {
    this.dialogRef.close({
      dataEvasione: this.evadiForm.getRawValue().dataEvasione,
      motivoEvasione: this.evadiForm.getRawValue().motivoEvasione,
    });
  }
}
